module.exports = __webpack_public_path__ + "static/media/19.Flow-Table.1305e330.webp";